import { render } from "./Dashboard.vue?vue&type=template&id=0bfbbc2e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0bfbbc2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfbbc2e"],['__file',"src/views/h5/crm/project/view/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bfbbc2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bfbbc2e', __exports__)) {
    api.reload('0bfbbc2e', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=0bfbbc2e&scoped=true", () => {
    api.rerender('0bfbbc2e', render)
  })

}


export default __exports__